export interface GatewayRoutesManifest {
    prefixes: string[];
    /// Pathnames served by React without treating them as prefixes.
    exact?: string[];
}

/// <summary>
/// Pathname only (`/achat/1`), ignoring query/hash and a missing leading slash.
/// </summary>
export function pathnameFromAppUrl(url: string): string {
    const withoutOrigin = url.replace(/^[a-zA-Z][a-zA-Z+.-]*:\/\/[^/]+/, '');
    const path = (withoutOrigin.split('?')[0] ?? '').split('#')[0] ?? '';
    if (!path) {
        return '/';
    }
    return path.startsWith('/') ? path : `/${path}`;
}

/// <summary>
/// True when nginx should serve React for this in-app URL. Never treat `"/"` as a prefix.
/// </summary>
export function isReactGatewayPath(
    url: string,
    prefixes: readonly string[],
    exact: readonly string[] = [],
): boolean {
    const pathname = pathnameFromAppUrl(url);
    if (exact.includes(pathname)) {
        return true;
    }
    return prefixes.some((prefix) => prefix !== '/' && (pathname === prefix || pathname.startsWith(prefix)));
}
